export function readStored(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
    // eslint-disable-next-line no-empty
  } catch {}
}

export function removeStored(key: string): void {
  try {
    localStorage.removeItem(key);
    // eslint-disable-next-line no-empty
  } catch {}
}

export function clearStored(): void {
  try {
    localStorage.clear();
    // eslint-disable-next-line no-empty
  } catch {}
}
